module.exports = __webpack_public_path__ + "static/media/coronavirus.eaef5058.png";